import React, { useRef } from "react";
import { useRemoteComponents } from "./internal/use-remote-components.js";
export function createBreadcrumbGroupLoader({ Fallback }) {
    return function BreadcrumbGroupLoader({ Skeleton, ...props }) {
        const ref = useRef(null);
        const components = useRemoteComponents(ref, { BreadcrumbGroup: Fallback });
        const Component = components.BreadcrumbGroup;
        if (Component) {
            return React.createElement(Component, { ...props });
        }
        if (Skeleton) {
            return React.createElement(Skeleton, { ref: ref, ...props });
        }
        return React.createElement("div", { ref: ref });
    };
}
